<template>

  <div class="header clearfix">
    <div class="logo">
      <router-link to="/"><img alt="logo" src="@/assets/logo.png"></router-link>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light">
      <ul class="navbar-nav">
        <li class="nav-item active"><router-link to="/" class="nav-link">الرئيسية</router-link></li>
      </ul>
    </nav>
  </div>

</template>

<script>
  export default {
    name: "Header",
  }
</script>

<style lang="scss" scoped>
.header {
  padding: 20px 0px;
  .logo {
    float: right;
    img {
      max-width: 160px;
    }
  }
  nav {
    float: left;
    padding: 40px 0;
  }
}
</style>
